import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../actions/ViewerManagement';
import ViewerManagementSelector from '../../../selectors/ViewerManagement';
import withAuth from '../../../common/WithAuth';
import ListViewer from '../../../pages/Admin/ViewerManagement/ListViewer';
import { ResendMailRequested, ClearResendMailData } from '../../../actions/Mail';

const mapStateToProps = (state) => {
    const viewerResults = ViewerManagementSelector.createViewerManagementResultsSelector()(state);
    const isLoading = state.viewerManagement.get.isFetching
    || state.viewerManagement.update.isFetching
    || state.viewerManagement.getCsvViewer.isFetching;

    return {
        viewerResults,
        viewers: state.viewerManagement.get.data,
        viewerUpdate: state.viewerManagement.update.data,
        errors: state.viewerManagement.update.errors,
        options: state.commonOptions.Options.data,
        isLoading,
        resendMailSuccess: state.mail.resend.success,
        viewerDownloadData: state.viewerManagement.getCsvViewer.data,
        successGetDownloadData: state.viewerManagement.getCsvViewer.success,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchListViewer: (params) => {
        dispatch(Actions.GetListEventOfViewerRequested(params));
    },
    updateViewer: (params) => {
        dispatch(Actions.UpdateStatusViewerRequested(params));
    },
    clearViewer: () => {
        dispatch(Actions.ClearListEventOfViewer());
    },
    resendMail: (params) => {
        dispatch(ResendMailRequested(params));
    },
    resetResendMailData: () => {
        dispatch(ClearResendMailData());
    },
    getCsvViewer: (params) => dispatch(Actions.GetCsvViewerRequested(params)),
    getCsvViewerClear: () => dispatch(Actions.GetCsvViewerClear()),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListViewer);
